

define(['angular', 'squid/index', './directive', 'pages/xo-sidebar/route', 'components/xo-login-components/src/onetouch-interstitial/route', 'components/xo-guest-components/src/guest-upgrade-interstitial/route', 'components/xo-guest-components/src/guest/currencyConversion/route'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('hermes.page.xo-signup.route', ['squid', 'hermes.page.xo-signup.directive', 'hermes.page.xo-sidebar.route']).factory('$SignupRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('SignupRoute', {
            name: 'signup',
            directive: 'xo-signup',
            titleContent: 'accountCreationGuest.heading',
            trackingData: {
                fptiState: 'signup',
                trackStateExit: true,
                templateName: 'signup.dust',
                pageGoal: 'Signup Start',
                pageQualifier: 'signup',
                buzname: {
                    'signup': {
                        'pagename': '%::fullpage-signup',
                        'pagename2': '%::fullpage-signup:member:hermes:',
                        'version': 'guest:%:'
                        // More page qualifiers come here...
                    } }
            },
            children: [{
                name: '$SidebarRoute',
                attributes: {
                    'back-uri': 'backUri',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$OneTouchUpsellRoute',
                attributes: {
                    token: 'token',
                    'on-complete': 'onComplete',
                    'disable-close-button': 'true',
                    'ignore-bg-clicks': 'true'
                }
            }, {
                name: '$GuestUpgradeInterstitialRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel'
                }
            }, {
                name: '$CurrencyConversionOptionsRoute',
                attributes: {
                    token: 'token',
                    'parent-model': 'singleStepModel',
                    'is-pre-plan': 'true',
                    'done-fn': 'onCurrencyConversionDone'
                }
            }]
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-signup/route.js
// module id = ./pages/xo-signup/route.js
// module chunks = 1